export class FbMetrics {
	static sendPageView() {
		// eslint-disable-next-line
		fbq('track', 'PageView');
	}
}
